import { useId, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import CloseButton from "react-bootstrap/CloseButton";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

/** The sign-up page for each choice. */
const SIGN_UP_PATHS = {
  UserRegistration: "/UserRegistration",
  Organization: "/Organization",
};

/**
 * The "Get Started Now - Create an Account as Player / Xcutta Manager" dialog (#277), opened by
 * the header's Sign Up, Home's Join Now, Login's "Register here" and the side banner's REGISTER
 * NOW. It was copied into each of them, and Home's copy shared its choice with the subscription
 * plans' radios, so after picking a plan it opened with nothing chosen and Continue did nothing.
 *
 * @param {object} props
 * @param {boolean} props.show
 * @param {() => void} props.onHide
 *
 * #290 The X sits in its own strip above the header image so it covers neither the image nor the
 * heading; Close is a grey secondary button as tall as Continue.
 */
export const SignUpChoiceModal = ({ show, onHide }) => {
  const navigate = useNavigate();
  const id = useId();
  const [choice, setChoice] = useState("UserRegistration");

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="sign-up-choice-modal">
      <div className="d-flex justify-content-end px-2 pt-2">
        <CloseButton aria-label="Close" onClick={onHide} />
      </div>
      <img src="../image/circle_full_width.png" width="100%" height={80} alt="" />

      <Modal.Body className="pt-0">
        <h2 className="text-center heading-get-started">
          <b>Get Started Now</b>
        </h2>
        <p className="text-center mb-4 mt-3">Create an Account as</p>

        <div className="grop-input-radio d-flex justify-content-center">
          <Form.Check
            className="me-3"
            label=" Player"
            type="radio"
            name={`${id}-sign-up`}
            value="UserRegistration"
            checked={choice === "UserRegistration"}
            onChange={(e) => setChoice(e.target.value)}
            id={`${id}-player`}
          />
          <Form.Check
            label="Xcutta Manager"
            type="radio"
            name={`${id}-sign-up`}
            value="Organization"
            checked={choice === "Organization"}
            onChange={(e) => setChoice(e.target.value)}
            id={`${id}-manager`}
          />
        </div>
        <Row>
          <Col md={12} className="text-center mt-4 pb-5">
            <Button className="text-center submit-btn" type="button" onClick={() => navigate(SIGN_UP_PATHS[choice])}>
              Continue
            </Button>
            <Button variant="secondary" className="text-center ms-3" type="button" onClick={onHide}>
              Close
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
